import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux'; 

import {
  Grid, Box,
  Paper, Typography, Link
} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';
import axios from 'axios';


import {useAppAuthContext} from '../../utils/AppAuthContext'

import {clearApplications} from  "../../store/applicationSlice"
import {clearFloors} from  "../../store/floorSlice"
import {clearVisitors} from  "../../store/visitorSlice"
import {clearReasons} from  "../../store/reasonSlice"
import {clearUsers} from  "../../store/userSlice"
import { useMsal } from '@azure/msal-react';



const LogoutPage = () => {

  const dispatch = useDispatch()
  const {loginComplete} = useAppAuthContext()

  const {instance,accounts} = useMsal();
  const logout = async (logoutType) =>  {
    if (logoutType === "popup") {
      instance.logoutPopup({ 
        mainWindowRedirectUri: "/"
      });
    } else if (logoutType === "redirect") {

      console.log("logout");
      const activeAccounts = await instance.getActiveAccount();
      console.log(activeAccounts);
      instance.logoutRedirect({ 
        account: activeAccounts
      });
    }
  }

  useEffect(()=>
  {
   
    if(loginComplete)
    {
      dispatch(clearApplications())
      dispatch(clearFloors())
      dispatch(clearVisitors())
      dispatch(clearReasons())
      dispatch(clearUsers())
      delete axios.defaults.headers.common["ExtraUserInfo"];
      logout("redirect")
    }
  
  
  
    },[loginComplete]
  )

  return (
    <Box>
         
      <Paper sx={{border:'none', justifyContent: "flex-start",p: 1}} elevation={0} >
        <Grid
           container
           spacing={2}
           direction={'column'}
           justify={'center'}
           alignItems={'center'}
        >
         <Grid item xs={12}>{'     '}   </Grid> 
         <Grid item xs={12}>
          <Typography variant='h6' gutterBottom sx={{align:'center'}} >
              You have successfully logged out.
          </Typography>
         </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' gutterBottom
              sx={{align:'center'}} >
              <Link component={RouterLink} to={'/login'}>Login Again</Link>
          </Typography>
        </Grid>
        

      </Grid>
        

      </Paper>
      
      
    </Box>
  );
}

export default LogoutPage
